<template>
  <div class="container-fluid p-0 m-0 pt-3 pb-5 ">
      <div class="row g-0 m-3 m-lg-0"  data-aos="fade" data-aos-delay="250" data-aos-easing="linear" data-aos-duration="1000">
          <div class="col-12 col-md-6 col-lg-4 me-0 me-lg-3 px-0 px-lg-4 resumenCol1">
              <div class="col-12 p-0 p-lg-5 pe-4 text-start">
                  <h2>{{$t('resumen.2022-en-resumen')}}</h2>
                  <h4 class="my-5 pe-5">{{$t('resumen.ha-seguido-progresando')}}</h4>
                  <localized-link to="/informe-financiero" class="btn mt-5 d-none d-lg-block">{{$t('resumen.informe-financiero')}}</localized-link>
              </div>
          </div>
          <div class="col-md-5 col-lg-7">
              <div class="row g-3">
                  <div class="col-12 col-lg-6" data-aos="fade-up" data-aos-easing="easy-out" data-aos-duration="1000">
                      <div class="resumenCol2 p-5 text-start fullHeight">
                          <h3>
                              <svg viewBox="0 0 80 75" width="80">
                                  <use :href="`${publicPath}icons.svg#personas`"/>
                              </svg>
                              <span style="vertical-align: bottom">{{$t('resumen.personas')}}</span>
                          </h3>
                          <hr class="mb-5">
                          <h4>{{$t('resumen.equipo')}}</h4>
                          <h1>+<AnimatedNumber
                                  ref='numA'
                                  :startAmount='0'
                                  :endAmount='21000'
                                  :duration='3'
                                  :separator=separator
                                  :decimals='0'
                                  :autoinit='true'
                          />
                          </h1>
                          <h4>{{$t('resumen.profesionales')}}</h4>
                          <hr>
                          <h4>{{$t('resumen.estabilidad')}}</h4>
                          <h1>+<AnimatedNumber
                                  ref='numB'
                                  :startAmount='0'
                                  :endAmount='90'
                                  :duration='3'
                                  :separator=separator
                                  :decimals='0'
                                  :autoinit='true'
                          />%</h1>
                          <h4>{{$t('resumen.de-contratos-indefinidos')}}</h4>
                          <hr>
                          <h4>{{$t('resumen.diversidad')}}</h4>
                          <h1>+<AnimatedNumber
                                  ref='numC'
                                  :startAmount='0'
                                  :endAmount='80'
                                  :duration='3'
                                  :separator=separator
                                  :decimals='0'
                                  :autoinit='true'
                          /></h1>
                          <h4>{{$t('resumen.nacionalidades')}}</h4>
                          <hr>
                          <h4>{{$t('resumen.formacion')}}</h4>
                          <h1>+<AnimatedNumber
                                  ref='numD'
                                  :startAmount='0'
                                  :endAmount='132700'
                                  :duration='3'
                                  :separator=separator
                                  :decimals='0'
                                  :autoinit='true'
                          /></h1>
                          <h4>{{$t('resumen.horas')}}</h4>
                      </div>
                  </div>
                  <div class="col-12 col-lg-6" data-aos="fade-up" data-aos-delay="500" data-aos-easing="easy-out" data-aos-duration="1000">
                      <div class="resumenCol3 p-5 text-start fullHeight">
                          <h3>
                              <svg viewBox="0 0 80 75" width="80">
                                  <use :href="`${publicPath}icons.svg#planeta`"/>
                              </svg>
                              <span style="vertical-align: bottom">{{$t('resumen.planeta')}}</span>
                          </h3>
                          <hr class="mb-5">
                          <h4 v-html="$t('resumen.emisiones-co')"></h4>
                          <h1>-<AnimatedNumber
                                  ref='numE'
                                  :startAmount='0'
                                  :endAmount='18'
                                  :duration='3'
                                  :separator=separator
                                  :decimals='0'
                                  :autoinit='true'
                          />%</h1>
                          <hr class="mb-5">
                          <h4>{{$t('resumen.consumo-agua')}}</h4>
                          <h1>-<AnimatedNumber
                                  ref='numF'
                                  :startAmount='0'
                                  :endAmount='28'
                                  :duration='3'
                                  :separator=separator
                                  :decimals='0'
                                  :autoinit='true'
                          />%</h1>
                          <hr class="mb-5">
                          <h4>{{$t('resumen.intensidad-energetica')}}</h4>
                          <h1>-<AnimatedNumber
                                  ref='numG'
                                  :startAmount='0'
                                  :endAmount='26'
                                  :duration='3'
                                  :separator=separator
                                  :decimals='0'
                                  :autoinit='true'
                          />%</h1>
                          <hr>
                          <h4>{{$t('resumen.generacion-residuos')}}</h4>
                          <h1>-<AnimatedNumber
                                  ref='numH'
                                  :startAmount='0'
                                  :endAmount='30'
                                  :duration='3'
                                  :separator=separator
                                  :decimals='0'
                                  :autoinit='true'
                          />%</h1>
                          <p class="mt-4 pt-1"><small>{{$t('resumen.evolucion-respecto-2021')}}</small></p>
                      </div>
                  </div>
                  <div class="col-12" data-aos="fade-up" data-aos-easing="easy-out" data-aos-duration="1000">
                      <div class="resumenCol4 p-5 text-start">
                          <div class="row justify-content-between">
                              <div class="col-12 col-lg-6 p-2 pe-0 pe-lg-5">
                                  <h3>
                                      <svg viewBox="0 0 80 75" width="80">
                                          <use :href="`${publicPath}icons.svg#prosperidad`"/>
                                      </svg>
                                      <strong style="vertical-align: bottom">{{$t('resumen.prosperidad')}}</strong>
                                  </h3>
                                  <hr class="mb-5">

                              </div>
                          </div>
                          <div class="row justify-content-between">
                              <div class="col-12 col-lg-6 p-2 pe-0 pe-lg-5">
                                  <h4>{{$t('resumen.cifra-negocio')}}</h4>
                                  <h1><AnimatedNumber
                                          ref='numI'
                                          :startAmount='0'
                                          :endAmount='2092'
                                          :duration='3'
                                          :separator=separator
                                          :decimals='0'
                                          :autoinit='true'
                                  /></h1>
                                  <h4>{{$t('resumen.millones-euros')}}</h4>
                                  <hr class="mb-5">
                                  <h4>{{$t('resumen.resultado-neto')}}</h4>
                                  <h1><AnimatedNumber
                                          ref='numJ'
                                          :startAmount='0'
                                          :endAmount='42'
                                          :duration='3'
                                          :separator=separator
                                          :decimals='0'
                                          :autoinit='true'
                                  /></h1>
                                  <h4>{{$t('resumen.millones-euros')}}</h4>
                                  <hr>

                              </div>
                              <div class="col-12 col-lg-6 p-2 pe-0 pe-lg-5">
                                  <h4>{{$t('resumen.EBITDA-consolidado')}}</h4>
                                  <h1><AnimatedNumber
                                          ref='numK'
                                          :startAmount='0'
                                          :endAmount='356'
                                          :duration='3'
                                          :separator=separator
                                          :decimals='0'
                                          :autoinit='true'
                                  /></h1>
                                  <h4>{{$t('resumen.millones-euros')}}<br><br></h4>
                                  <hr class="mb-5">
                                  <h4>{{$t('resumen.inversiones')}}</h4>
                                  <h1><AnimatedNumber
                                          ref='numL'
                                          :startAmount='0'
                                          :endAmount='135'
                                          :duration='3'
                                          :separator=separator
                                          :decimals='0'
                                          :autoinit='true'
                                  /></h1>
                                  <h4>{{$t('resumen.millones-euros')}}</h4>
                                  <hr>

                              </div>
                          </div>

                      </div>
                  </div>
              </div>
          </div>
      </div>

  </div>

    <!-- Footer -->
    <footer>
        <div class="row p-0 g-0">
            <div class="col-6 border-top border-dark">
                <localized-link to="/roca-group-2022/presentacion" class="row justify-content-start p-0 m-0 my-0 my-lg-5">
                    <div class="col-4 col-lg-auto p-0 ps-0 ps-lg-5 ms-0 ms-lg-5">
                        <svg class="hoverEfect svg-icon iconFletxaLeft">
                            <use :href="`${publicPath}icons.svg#fletxaLeft`"/>
                        </svg>
                    </div>
                    <div class="col-6 col-lg-auto text-start p-0 mt-5">
                        <h6 class="hoverEfect mt-4 mt-lg-0">{{$t('site.anterior')}}</h6>
                        <h2 class="hoverEfect d-none d-lg-block text-uppercase">{{ $t("nav.presentacion") }}</h2>
                    </div>
                </localized-link>
            </div>
            <div class="col-6 border-top border-start border-dark">
                <localized-link to="/roca-group-2022/roca-group-en-el-mundo" class="row justify-content-end p-0 m-0 my-0 my-lg-5">

                    <div class="col-6 col-lg-auto text-end p-0 mt-5">
                        <h6 class="hoverEfect mt-4 mt-lg-0">{{$t('site.siguiente')}}</h6>
                        <h2 class="hoverEfect d-none d-lg-block text-uppercase">{{ $t("nav.en-el-mundo") }}</h2>
                    </div>
                    <div class="col-4 col-lg-auto p-0 pe-5 me-0 me-lg-5">
                        <svg class="hoverEfect svg-icon iconFletxaRight">
                            <use :href="`${publicPath}icons.svg#fletxaRight`"/>
                        </svg>
                    </div>

                </localized-link>
            </div>
        </div>
    </footer>
    <!-- Footer -->

</template>

<script>
    import AnimatedNumber from "vue3-autocounter";
    export default {
        components: {
            AnimatedNumber
        },
        props: {
            hasChildren: Boolean
        },
        data() {
            return {
                publicPath: process.env.BASE_URL,
                separator: '.'
            }
        },
        mounted() {
            document.addEventListener('aos:in:counter', this.startCounter);
            if (this.$i18n.locale == "es") {
                this.separator = '.';
            } else {
                this.separator = ',';
            }
        },
        methods: {
            startCounter() {
                if (this.$refs.numA != null) {
                    this.$refs.numA.start();
                }
                if (this.$refs.numB != null) {
                    this.$refs.numB.start();
                }
                if (this.$refs.numC != null) {
                    this.$refs.numC.start();
                }
                if (this.$refs.numD != null) {
                    this.$refs.numD.start();
                }
                if (this.$refs.numE != null) {
                    this.$refs.numE.start();
                }
                if (this.$refs.numF != null) {
                    this.$refs.numF.start();
                }
                if (this.$refs.numG != null) {
                    this.$refs.numG.start();
                }
                if (this.$refs.numH != null) {
                    this.$refs.numH.start();
                }
                if (this.$refs.numI != null) {
                    this.$refs.numI.start();
                }
                if (this.$refs.numJ != null) {
                    this.$refs.numJ.start();
                }
                if (this.$refs.numK != null) {
                    this.$refs.numK.start();
                }
                if (this.$refs.numL != null) {
                    this.$refs.numL.start();
                }
            }
        }
    };
</script>
